<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card shadow="never">
          <h1 style="text-align:left;margin-top:unset;">Log Create Shipment</h1>
          <el-row >
            <el-col class="text-md-left" :span="24">
              <el-form label-position="top" label-width="100px" @submit.native.prevent="() => {}">
                <el-form-item label="เลือกวันที่ต้องการ">
                  <el-date-picker
                    v-model="datePick"
                    type="daterange"
                    range-separator="To"
                    start-placeholder="Start date"
                    end-placeholder="End date"></el-date-picker>
                  <el-button
                    type="primary"
                    style="margin-left:10px;"
                    @click="SearchLogCreateShipment">ค้นหา</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="24">
                <el-row style="margin-bottom: 20px">
                  <el-col :lg="6" :sm="24">
                    <!-- <el-input v-model="filters[0].value" placeholder="ค้นหาชื่อร้านค้า" @input="filterShopName"></el-input> -->
                    <el-input v-model="textfilter" placeholder="ค้นหาชื่อร้านค้า" @input="filterShopName"></el-input>
                  </el-col>
                </el-row>

                <el-row style="margin-bottom: 10px">
                  <el-col :lg="3" :md="24" class="text-lg-left">
                    <el-checkbox v-model="showOrderFail" label="แสดงเฉพาะออเดอร์ที่ไม่สำเร็จ" border @input="handleShowOrderFail"></el-checkbox>
                  </el-col>
                  <el-col :lg="10" :md="24">
                    <div style="font-size:18px;margin-top: 5px;font-weight: bold;color:red;">ออเดอร์ทั้งหมดที่ไม่สำเร็จทั้งหมด : {{orderFailAll}} ออเดอร์</div>
                  </el-col>
                </el-row>

              <data-tables
                :data="shopArray"
                style="width: 100%"
                class="dataTable">
                <el-table-column prop="shop_name" label="Shop Name" width="250" sortable></el-table-column>
                <el-table-column label="จำนวนออเดอร์" width="180" align="center" sortable prop="orderNew">
                  <div class="text-md-center" slot-scope="scope">{{countOrder(scope.row.orderNew)}}</div>
                </el-table-column>
                <el-table-column label="จำนวนออเดอร์ที่สำเร็จ" width="220" sortable prop="orderPassCount">
                  <div class="text-md-left" slot-scope="scope">
                    <span
                        class="text-order-pass-count"
                        @click="showDetail(scope.row.orderNew,'pass')"
                    >
                        {{scope.row.orderPassCount}}
                    </span>
                  </div>
                </el-table-column>
                <el-table-column label="จำนวนออเดอร์ที่ไม่สำเร็จ" width="220" sortable prop="orderFailCount">
                  <div class="text-md-left" slot-scope="scope">
                    <span
                        class="text-order-fail-count"
                        @click="showDetail(scope.row.orderNew,'fail')"
                    >
                        {{scope.row.orderFailCount}}
                    </span>
                  </div>
                </el-table-column>
              </data-tables>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <log-detail-create-chipment
      :dialogShow="dialogShopShow"
      :status="status"
      @closeModal="dialogShopShow = false"
      :orderDetail="orderDetail"
    ></log-detail-create-chipment>
    <log-detail-create-shipment-fail :dialogShow="dialogShopShowFail"
      :status="status"
      @closeModal="dialogShopShowFail = false"
      :orderDetail="orderDetail"/>
  </div>
</template>
<script>
import mixinExcel from '@/mixins/exportExcel.js'
import fgApi from '@/services/fillgoods'
import logDetailCreateChipment from '@/components/LogOrder/LogDetailCreateShipment'
import logDetailCreateShipmentFail from '@/components/LogOrder/LogDetailCreateShipmentFail'
export default {
    name: 'ExportStatusOrder',
    mixins: [mixinExcel],
    components: { logDetailCreateChipment, logDetailCreateShipmentFail },
    data () {
        return {
            datePick: null,
            shopArray: [],
            dialogShopShow: false,
            dialogShopShowFail: false,
            orderDetail: [],
            filters: [
                {
                    prop: 'shop_name',
                    value: ''
                }
            ],
            status: '',
            orderFailAll: 0,
            showOrderFail: false,
            textfilter: '',
            OrderListsTmp: null
        }
    },
    created () {
        let dateTo = new Date()
        let dateFrom = new Date()
        dateFrom.setDate(dateTo.getDate() - 14)
        this.datePick = [dateTo, dateTo]
        this.SearchLogCreateShipment()
    },
    methods: {
        async SearchLogCreateShipment () {
            this.$loading({
                text: 'กำลังโหลดข้อมูล...'
            })
            let dateFrom = this.datePick[0].getFullYear() + '-' + String(this.datePick[0].getMonth() + 1).padStart(2, '0') + '-' + String(this.datePick[0].getDate()).padStart(2, '0') + ' 00:00:00'
            let dateTo = this.datePick[1].getFullYear() + '-' + String(this.datePick[1].getMonth() + 1).padStart(2, '0') + '-' + String(this.datePick[1].getDate()).padStart(2, '0') + ' 23:59:59'
            let param = {
                from: dateFrom,
                to: dateTo
            }

            // console.log(this.getCreateShipmentErrCode('0501'))
            try {
                let res = await fgApi.courier.getLogCreateShipment(param)
                console.log(res)
                var outObject = res.data.reduce((a, e) => {
                    let estKey = e['shopId'];
                    (a[estKey] ? a[estKey] : (a[estKey] = null || [])).push(e)
                    return a
                }, {})
                this.shopArray = Object.values(outObject).map(e => {
                    let a = []
                    let z = {}
                    let y = []
                    e.map(s => {
                        a = []
                        let date = { create: s.createdAt }
                        s.responseModel.map(m => {
                            a.push({ ...m, ...date })
                        })
                        let b = { newres: a }
                        z = { ...s, ...b }
                        y.push(z)
                    })
                    let sortArr = y.map(x => x.newres).flat()
                    sortArr.sort(function (a, b) {
                        var c = new Date(a.create).getTime()
                        var d = new Date(b.create).getTime()
                        return d - c
                    })
                    return {
                        shop_id: e[0].shopId,
                        shop_name: e[0].shopName,
                        orderNew: sortArr,
                        orderPass: this.handleOrder(sortArr, 'pass'),
                        orderPassCount: this.CountOrderResult(sortArr, 'pass'),
                        orderFail: this.handleOrder(sortArr, 'fail'),
                        orderFailCount: this.CountOrderResult(sortArr, 'fail')
                    }
                })
                this.setOrderFailCount(this.shopArray)
                this.shopArray.sort(this.compareOrderFailLogCreateShipment)
                this.OrderListsTmp = [...this.shopArray]
                console.log(this.shopArray)
            } catch (error) {
                console.log(error)
            }
            this.$loading().close()
        },
        CountOrderResult (val, status) {
            if (status === 'pass') {
                let orderResult = val.filter(e => {
                    if (e.errorCode === '' || e.errorCode === '0503') {
                        return e
                    }
                })
                var outObject = orderResult.reduce(function (a, e) {
                    let estKey = e['orderNumber'];
                    (a[estKey] ? a[estKey] : (a[estKey] = null || [])).push(e)
                    return a
                }, {})
                return Object.keys(outObject).length
            } else if (status === 'fail') {
                let orderResult = val.filter(e => {
                    if (e.errorCode !== '0503' && e.errorCode !== '') {
                        return e
                    }
                })
                var outObjectFail = orderResult.reduce(function (a, e) {
                    let estKey = e['orderNumber'];
                    (a[estKey] ? a[estKey] : (a[estKey] = null || [])).push(e)
                    return a
                }, {})
                return Object.keys(outObjectFail).length
            }
        },
        showDetail (data, status) {
            this.status = ''
            if (status === 'pass') {
                let orderResult = data.filter(e => {
                    if (e.errorCode === '' || e.errorCode === '0503') {
                        return e
                    }
                })
                this.orderDetail = orderResult
                this.status = 'pass'
                this.dialogShopShowFail = !this.dialogShopShowFail
            } else if (status === 'fail') {
                let orderResult = data.filter(e => {
                    if (e.errorCode !== '0503' && e.errorCode !== '') {
                        return e
                    }
                })
                this.orderDetail = orderResult
                this.status = 'fail'
                this.dialogShopShowFail = !this.dialogShopShowFail
            }
        },
        handleOrder (data, status) {
            if (status === 'pass') {
                let orderResult = data.filter(e => {
                    if (e.errorCode === '' || e.errorCode === '0503') {
                        return e
                    }
                })
                return orderResult
            } else if (status === 'fail') {
                let orderResult = data.filter(e => {
                    if (e.errorCode !== '0503' && e.errorCode !== '') {
                        return e
                    }
                })
                return orderResult
            }
        },
        countOrder (val) {
            let orderResult = val.filter(e => !e.errorCode)
            var outObjectPass = orderResult.reduce(function (a, e) {
                let estKey = e['orderNumber'];
                (a[estKey] ? a[estKey] : (a[estKey] = null || [])).push(e)
                return a
            }, {})
            let countPass = Object.keys(outObjectPass).length

            let orderResultFail = val.filter(e => e.errorCode)
            var outObject = orderResultFail.reduce(function (a, e) {
                let estKey = e['orderNumber'];
                (a[estKey] ? a[estKey] : (a[estKey] = null || [])).push(e)
                return a
            }, {})
            let countfail = Object.keys(outObject).length
            return (countPass + countfail)
        },
        filterShopName (value) {
            this.showOrderFail = false
            if (value.length > 0) {
                this.shopArray = [...this.OrderListsTmp]
                this.shopArray = this.OrderListsTmp.filter(e => {
                    let searchText = value.toLowerCase()
                    let strLowerCase = e.shop_name.toLowerCase()
                    if (strLowerCase.indexOf(searchText) > -1) {
                        return e
                    }
                })
                this.setOrderFailCount(this.shopArray)
                this.shopArray.sort(this.compareOrderFailLogCreateShipment)
            } else {
                this.shopArray = [...this.OrderListsTmp]
                this.setOrderFailCount(this.shopArray)
                this.shopArray.sort(this.compareOrderFailLogCreateShipment)
            }
        },
        setOrderFailCount (order) {
            let count = 0
            order.forEach(e => {
                count = count + e.orderFailCount
            })
            this.orderFailAll = count
        },
        handleShowOrderFail (value) {
            this.textfilter = ''
            if (value) {
                this.shopArray = [...this.OrderListsTmp]
                this.shopArray = this.OrderListsTmp.filter(e => e.orderFailCount > 0)
                this.setOrderFailCount(this.shopArray)
                this.shopArray.sort(this.compareOrderFailLogCreateShipment)
            } else {
                this.shopArray = [...this.OrderListsTmp]
                this.setOrderFailCount(this.shopArray)
                this.shopArray.sort(this.compareOrderFailLogCreateShipment)
            }
        }
    }
}
</script>

<style lang="scss">
.el-icon-info {
  cursor: pointer;
}
.dataTable {
  .el-table .cell {
    font-size: 16px;
  }
}

.text-order-pass-count {
    margin-right: 30px;
    cursor: pointer;
    text-decoration: underline;
}
.text-order-fail-count {
    font-weight: 700;
    color: red;
    margin-right: 30px;
    font-size: 16px;
    cursor: pointer;
    text-decoration: underline;
}
</style>
